import React, { type ReactElement } from 'react';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from '@atlassian/jira-intl';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { StyledBox, StyledText } from '../../../../common/ui/picker/styled.tsx';
import messages from './messages.tsx';

type Props = {
	children: ReactElement;
};

const NoOptionsMessageContainer = ({ children }: Props) => {
	if (isVisualRefreshEnabled()) {
		return (
			<Stack space="space.150" alignInline="center">
				{children}
				<Text color="color.text">
					<FormattedMessage {...messages.noOptionsPrimaryMessage} />
				</Text>
				<Text size="small" color="color.text.subtle">
					<FormattedMessage {...messages.noOptionsSecondaryMessage} />
				</Text>
			</Stack>
		);
	}
	return (
		<>
			<StyledBox height={72}>{children}</StyledBox>
			<StyledText>
				<FormattedMessage {...messages.noOptionsMessage} />
			</StyledText>
		</>
	);
};

export const NoOptionsMessage = (): React.JSX.Element => (
	<>
		{/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */}
		<StyledBox data-testid="jql-builder-basic.ui.jql-editor.picker.async-select.select.no-options-message">
			<NoOptionsMessageContainer>
				<StatusErrorIcon label="" color={token('color.icon')} />
			</NoOptionsMessageContainer>
		</StyledBox>
		<FireUiAnalytics actionSubject="emptyState" action="viewed" actionSubjectId="noMatches" />
	</>
);
export default NoOptionsMessage;
